import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import { catchError, combineLatest, map, Observable, throwError } from 'rxjs';
import { DetailedTdRateBank, TdRateBank, TdRateBankToAddOrUpdate } from './td-rate-bank.model';

@Injectable({
  providedIn: 'root'
})
export class TdRatesBanksService {
  private apiEndpoint = `${environment.apiEndpoint}/api/td-rates-banks`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) {}

  public getTdRateBanks$(): Observable<TdRateBank[]> {
    return this.http.get<TdRateBank[]>(this.apiEndpoint).pipe(
      catchError((error: any) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public getTdRateBank$(id: number): Observable<DetailedTdRateBank> {
    return this.http.get<DetailedTdRateBank>(`${this.apiEndpoint}/${id}`).pipe(
      catchError((error: any) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public insertTdRateBank$(TdRateBank: TdRateBankToAddOrUpdate): Observable<DetailedTdRateBank> {
    return this.http.post<DetailedTdRateBank>(this.apiEndpoint, TdRateBank).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public updateTdRateBank$(id: number, TdRateBank: TdRateBankToAddOrUpdate): Observable<DetailedTdRateBank> {
    return this.http.put<DetailedTdRateBank>(`${this.apiEndpoint}/${id}`, TdRateBank).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public deleteTdRateBank$(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiEndpoint}/${id}`).pipe(
      catchError((error) => {
        this.logger.error(error);
        return throwError(() => error);
      })
    );
  }

  public deleteMultipleTdRateBanks$(ids: number[]): Observable<void> {
    return combineLatest(ids.map((id) => this.deleteTdRateBank$(id))).pipe(map(() => {}));
  }
}
